import React, {useState} from 'react';
import $ from 'jquery';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import ProgressBar from 'react-animated-progress-bar';
import CV from '../Awshad CV.pdf';

class About extends React.Component {

    render(){
        return (
            <section id="about" className="about">
                <div className="about-me container">
    
                    <div className="section-title">
                        <h2>About</h2>
                            <p>Learn more about me</p>
                    </div>
    
                    <div className="row">
                        <div className="col-lg-4" data-aos="fade-right">
                            <img src="assets/img/Me1.jpg" className="img-fluid" alt="" />
                        </div>
                        <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
  <h3>Full Stack Developer</h3>
  <p className="font-italic text-justify">
    With over 5 years of experience as a full-stack web developer, I have a proven track record of designing and implementing scalable, efficient, and user-centric web applications. My expertise extends across both front-end and back-end development, utilizing modern frameworks to build solutions that drive results. I am passionate about continuous learning, problem-solving, and collaborating with teams to deliver high-quality, innovative projects that exceed user expectations.
  </p>
  <p className="font-italic text-justify">
    I hold a BEng (Hons) in Software Engineering and currently work as a Software Engineer at HCL Sri Lanka, where I have honed my technical skills and creative problem-solving abilities. My proficiency in web development is complemented by experience in Adobe XD and Photoshop, enabling me to design intuitive and visually appealing user interfaces. Notably, my final project was awarded an 'A', underscoring my dedication to excellence and impactful work.
  </p>
  <div className="row">
    <div className="col-lg-6">
      <ul>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Birthday:</strong> 2nd December 1998
        </li>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Email:</strong> mawsa3454@gmail.com
        </li>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Phone:</strong> +94756800099
        </li>
        <li>
          <i className="icofont-rounded-right"></i> <strong>City:</strong> Batticaloa, Sri Lanka
        </li>
      </ul>
    </div>
    <div className="col-lg-6">
      <ul>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Age:</strong> 26
        </li>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Gender:</strong> Male
        </li>
        <li>
          <i className="icofont-rounded-right"></i> <strong>Degree:</strong> Bachelor's
        </li>
        // <li>
        //   <i className="icofont-rounded-right"></i> <strong>Freelance:</strong> Available
        // </li>
      </ul>
    </div>
  </div>
</div>

                    </div>
    
                </div>
    
    
                {/* <div className="counts container">
    
                    <div className="row">
    
                        <div className="col-lg-3 col-md-6">
                            <div className="count-box">
                                <i className="icofont-simple-smile"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={100}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Happy Clients</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-md-0">
                            <div className="count-box">
                                <i className="icofont-document-folder"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={120}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Projects</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                            <div className="count-box">
                                <i className="icofont-live-support"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={125}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Hours Of Support</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                            <div className="count-box">
                                <i className="icofont-users-alt-5"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={5}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Hard Workers</p>
                            </div>
                        </div>
    
                    </div>
    
                </div> */}
    
                <div className="skills container">    
                    <div className="section-title">
                        <h2>Skills</h2>
                    </div>    
                    <div className="row skills-content">
    
                        <div className="col-lg-6">
    
                            <div className="progress">
                                <span className="skill">HTML </span>                                
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="100"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />                       
                            </div>

                            <div className="progress">
                                <span className="skill">CSS </span>                                
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="90"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />                       
                            </div>
    
                            <div className="progress">
                                <span className="skill">Bootstrap </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="90"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
    
                            <div className="progress">
                                <span className="skill">JavaScript</span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="75"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>

                            <div className="progress">
                                <span className="skill">jQuery</span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="80"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>

                            <div className="progress">
                                <span className="skill">Ajax</span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="70"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>   
    
                            <div className="progress">
                                <span className="skill">React</span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="70"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div> 
                        </div>
    
                        <div className="col-lg-6">
    
                            <div className="progress">
                                <span className="skill">PHP </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="90"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
                            <div className="progress">
                                <span className="skill">Laravel </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="90"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
                            <div className="progress">
                                <span className="skill">ASP.NET </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="80"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>

                            <div className="progress">
                                <span className="skill">MySQL </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="80"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
                            <div className="progress">
                                <span className="skill">MSSQL </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="80"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
    
                            <div className="progress">
                                <span className="skill">Adobe Photoshop </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="80"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>

                            <div className="progress">
                                <span className="skill">Adobe XD </span>
                                <ProgressBar
                                    width="100%"
                                    height="10px"
                                    rect
                                    percentage="90"
                                    rectBorderRadius="30px"
                                    bgColor="#18a7d2"
                                />
                            </div>
    
                        </div>    
                    </div>    
                </div>
    
                <div className="interests container">
    
                    <div className="section-title">
                        <h2>Interests</h2>
                    </div>
    
                    <div className="row">
                        <div className="col-lg-3 col-md-4">
                            <div className="icon-box">
                                <i className="ri-layout-6-line" style={{ color: "#ffbb2c" }}></i>
                                <h3>Web Designing</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">
                                <i className="ri-code-box-line" style={{ color: "#5578ff" }}></i>
                                <h3>Web Development</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                            <div className="icon-box">
                                <i className="ri-gamepad-line" style={{ color: "#e80368" }}></i>
                                <h3>Gaming</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                            <div className="icon-box">
                                <i className="ri-riding-fill" style={{ color: "#e361ff" }}></i>
                                <h3>Travelling</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-book-line" style={{ color: "#47aeff" }}></i>
                                <h3>Books</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-cup-line" style={{ color: "#ffa76e" }}></i>
                                <h3>Coffee</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-bug-line" style={{ color: "#11dbcf" }}></i>
                                <h3>Debugging</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-ancient-pavilion-line" style={{ color: "#4233ff" }}></i>
                                <h3>Camping</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-run-fill" style={{ color: "#b2904f" }}></i>
                                <h3>Athelete</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-basketball-line" style={{ color: "#b20969" }}></i>
                                <h3>Volley Ball</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-camera-3-line" style={{ color: "#ff5828" }}></i>
                                <h3>Photography</h3>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 mt-4">
                            <div className="icon-box">
                                <i className="ri-tv-2-line" style={{ color: "#29cc61;" }}></i>
                                <h3>Netflix</h3>
                            </div>
                        </div>
                    </div>
    
                </div>
    
            </section>
        )
    }
    
}

export default About
